(function() {

    var shoswiper = new Swiper('.shorts-swiper-wrap .swiper', {
        direction: 'vertical',
        navigation: {
            nextEl: ".shorts-swiper-wrap .swiper-button-next",
            prevEl: ".shorts-swiper-wrap .swiper-button-prev",
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
        },
        centeredSlides: true,
        observer: true,
        observeParents: true,
        spaceBetween: 28,
        slidesPerView: 1,
        virtual: {
            slides: (function () {
                var slides = [];
                
                return slides;
            })(),
            cache: false,
        },
    });

    // 카테고리 템플릿
    var superCategoryTemplate = '' +
        '<li><a href="#">전체</a></li>' +
        '{{#each item in list}}' +
        '    <li>' +
        '        <a href="#{{item.categoryId}}" data-category="{{item.categoryId}}" onclick="return false;">{{item.categoryName}}</a>' +
        '    </li>' +
        '{{/each}}';

    // 목록 템플릿
    var listTemplate = '' +
        '{{#each (item, index) in list}}' +
        '    <li>' +
        '        <a href="#" class="short-link" data-index="{{index}}" data-control="modal" data-contents="{{item.storyTitle}}">' +
        '            <figure class="short-thumb">' +
        '                <img src="{{item.storyMainThumbnailPath}}{{item.storyMainThumbnailServerName}}" alt="{{item.storyMainThumbnailAltText}}">' +
        '            </figure>' +
        '            <p class="tit">{{#raw item.storyTitle}}</p>' +
        '        </a>' +
        '    </li>' +
        '{{/each}}';

    // 1분퀵뷰 팝업 슬라이더 템플릿
    var shortsTemplate = '' +
        '{{#if storyMovieGubun == "youtube"}}' +
        '    <div class="youtube-player" id="youtube-player-{{index+1}}" data-video-id="{{videoId}}" data-story-id="{{storyId}}"></div>' + // 2J2SB4wxl3Q
        '{{#else}}' +
        '    <video class="lazyload" poster="{{storyMainThumbnailPath}}{{storyMainThumbnailServerName}}" muted="" playsinline="" webkit-playsinline="" controls="" data-story-id="{{storyId}}" data-index="{{index}}" aria-label="{{index+1}} / {{listLen}}">' + 
        '        <source src="{{storyMovieUrl}}" type="video/mp4">' + // https://www.lge.co.kr/kr/brands/gram/shortform/gramdictionary_RTX3050_2023.mp4
        '    </video>' +
        '{{/if}}';

    var quickView = {
        init: function() {
            var self = this;
            var $paginationContainer = $('div.story-list-wrap .pagination');

            // 1. 라이브러리가 로드되기 전에 클릭되는 것을 막기 위해 우선 비활성화
            $paginationContainer.css('pointer-events', 'none');

            vcui.require(['ui/pagination'], function () {
                self.setting();
                self.bindEvents();

                // 최초 조회
                var urlParams = new URLSearchParams(window.location.search);
                self.requestSuperCategoryData(urlParams);
                self.requestData(urlParams);

                // 3. 모든 준비가 끝나면 다시 활성화
                $paginationContainer.css('pointer-events', 'auto');
            });
        },

        setting: function() {
            var self = this;
            var $contents = $('div.story-list-wrap');

            // 페이지네이션 컴포넌트 초기화
            self.$pagination = $contents.find('div.pagination').vcPagination();
            self.isInitialLoad = true; // 초기 로드 플래그
            
            // 1분퀵뷰 팝업 데이터
            self.shortsData = {
                    list : [], // 해설 데이터
                    players : {}, // YouTube IFrame API를 통해 동영상 제어
                    totalCount : 0, // 전체 아이템 수
                    totalPageCount : 0, // 전체 페이지수
                    currentPage : 0, // 현재 페이지
                    isFirst : false // 상태
            };

            self.countPerPage = vcui.detect.isMobile ? 12 : 15;
        },

        bindEvents: function() {
            var self = this;

            // 2. 라이브러리가 제공하는 안정적인 'page_click' 이벤트를 다시 사용
            self.$pagination.on('page_click', function(e, page) {
                var urlParams = new URLSearchParams(window.location.search);
                urlParams.set('page', page);
                self.requestData(urlParams);
            });

            // 카테고리 클릭 이벤트
            $('div.page-header ul.tabs').on('click', 'a', function(e) {
                e.preventDefault();
                var urlParams = new URLSearchParams(window.location.search);
                var superCategoryId = $(this).data('category');
                superCategoryId ? urlParams.set('superCategoryId', superCategoryId) : urlParams.delete('superCategoryId');
                urlParams.set('page', '1'); // 탭 변경 시 첫 페이지로 이동
                self.requestData(urlParams);
                self.updateTabClasses({superCategoryId: superCategoryId}); // 탭의 'on' 클래스 업데이트
            });

            // 컨텐츠 클릭 이벤트
            $('div.story-list ul.quick-view').on('click', 'a', function(e) {
                e.preventDefault();
                var data = $(this).data();
                var index = data.index || 0;
                if (shoswiper) {
                    // 슬라이드 데이터 초기화
                    $.extend(self.shortsData, {
                        list : [], // 해설 데이터
                        players : {},
                        isFirst : true // 상태
                    });
                    var urlParams = new URLSearchParams(window.location.search);
                    self.requestShortsData(urlParams.get('page') || 1, index);
                    $('#shorts-popup').vcModal('open');
                    $(this).addClass('activeItem');
                    setTimeout(function() {
                        $(document).find('.shorts-swiper-wrap .swiper-slide').attr('inert', '');
                        $(document).find('.shorts-swiper-wrap .swiper-slide-active').removeAttr('inert');
                    }, 300);
                }
            });

            // motion 이미지 처리 함수
            function showMotionImg() {
                var $motionImg = $('.motion-img');
                if (window.innerWidth < 768 && $('#shorts-popup').is(':visible') && !$motionImg.hasClass('active')) {
                    $motionImg.addClass('active').delay(700).fadeOut(700);
                }
            }

            // 컨텐츠 첫 클릭 시 motion 이미지 표시
            $('div.story-list ul.quick-view').one('click', 'a', function(e) {
                e.preventDefault();
                showMotionImg();
            });

            // 윈도우 리사이즈 시 motion 이미지 처리
            $(window).on('resize', function() {
                showMotionImg();
            });

            // 1분퀵뷰 팝업 '해설' 클릭 이벤트
            $('#shorts-popup').on('click', '.btn-subtitle', function(e) {
                e.preventDefault();
                var index = shoswiper.activeIndex;
                var data = self.shortsData.list[index];
                $('#shortsTitle').html(data.storyTitle);
                $('#shortsDescription').html(data.storyDesc);
                $('#shorts-popup .video-cap-section').show().focus();
            });

            // 1분퀵뷰 팝업 '해설' 닫기 이벤트
            $('#shorts-popup').on('click', '.btn-subtitle-close', function(e) {
                e.preventDefault();
                $(this).parents('.video-cap-section').hide();
                $(this).parents('#shorts-popup').find('.btn-subtitle').focus();
            });

            // 1분퀵뷰 팝업 '닫기' 이벤트
            $('#shorts-popup .ui_modal_close').on('click', function(e) {
                // 해설 닫기
                $('#shorts-popup').find(".video-cap-section").hide();
                // 모든 비디오를 일시정지
                $('#shorts-popup .swiper-slide video').each(function () {
                    this.pause();
                });
                // 모든 유뷰트 플레이어 제거
                $.each(Object.keys(self.shortsData.players), function(index, key) {
                    self.shortsData.players[key].destroy();
                    delete self.shortsData.players[key]; // 객체 참조 제거
                });
                // swiper slides 제거
                shoswiper.virtual.slides = [];
                shoswiper.update();
                // 포커스
                setTimeout(function () {
                    $('div.story-list ul.quick-view a.activeItem').removeClass('activeItem').focus();
                }, 300);
            });

            // swiper 이벤트
            shoswiper.on('slideChange', function(){
                // 해설닫기
                $('#shorts-popup').find(".video-cap-section").hide();
                // 모든 mp4 pause
                $('#shorts-popup .swiper-slide').each(function() {
                    var $video = $(this).find('video');
                    var isMp4 = $video.length > 0;
                    if (isMp4) {
                        $video[0].pause();
                        $video[0].currentTime = 0;
                    }
                });
                // 모든 youtube pause
                $.each(Object.keys(self.shortsData.players), function(index, key) {
                    var player = self.shortsData.players[key];
                    if (key != 'youtube-player-' + (shoswiper.activeIndex+1)) {
                        player.pauseVideo();
                        player.seekTo(0);
                    }
                });
            });

            shoswiper.on('slideChangeTransitionStart', function(){
                // 1분퀵뷰 팝업 - 다음 페이지 조회
                if (shoswiper.isEnd) {
                    var shortsCurrentPage = parseInt(self.shortsData.currentPage, 10);
                    if (shortsCurrentPage < self.shortsData.totalPageCount) {
                        self.requestShortsData(shortsCurrentPage + 1); // 다음 페이지 조회
                    } else {
                        self.requestShortsData(1); // 마지막 페이지면 1페이지 조회
                    }
                }
            });

            shoswiper.on('slideChangeTransitionEnd', function(){
                setTimeout(function() {
                    $(document).find('.shorts-swiper-wrap .swiper-slide').attr('inert', '');
                    $(document).find('.shorts-swiper-wrap .swiper-slide-active').removeAttr('inert');
                }, 300)
                // 현재 활성 슬라이드의 비디오 처리
                var $activeSlide = $('#shorts-popup .swiper-slide-active');
                var $video = $activeSlide.find('video');
                var isMp4 = $video.length > 0;

                if (isMp4) {
                    // 동영상 시청 완료 시 다음 슬라이드로 이동
                    $video.on('ended', function() {
                        shoswiper.slideNext();
                        $video.off('ended');
                    });
                    // 비디오 로드 완료 시 비디오 재생
                    $video.one('canplaythrough', function() {
                        $video[0].muted = true;
                        $video[0].loop = false;
                        $video[0].play();
                    });
                    // GA 태깅
                    $video.one('playing', function() {
                        var index = shoswiper.activeIndex;
                        var data = self.shortsData.list[index];
                        self.pushDataLayer(data.storyTitle);
                    });

                    // 비디오 로드 시작
                    $video[0].load();
                }

                // 생성된 DOM 기준으로 youtube 컨테츠가 포함되어 있으면 플레이어 생성
                var $domSlide = $('#shorts-popup .swiper-slide');
                var domSlideIds  = [];
                $.each($domSlide, function(sIndex, slide) {
                    var $youtubeSlide = $(slide).find('.youtube-player');
                    var isYoutube = $youtubeSlide.length > 0;
                    if (!isYoutube) return;

                    var slideId = $youtubeSlide[0].id;
                    domSlideIds.push(slideId);

                    if (Object.keys(self.shortsData.players).includes(slideId)) { // 기존 플레이어
                        if (slideId == 'youtube-player-' + (shoswiper.activeIndex+1)) { // 활성화된 슬라이드
                            self.shortsData.players[slideId].mute();
                            self.shortsData.players[slideId].playVideo();
                        }
                    } else { // 플레이어 없으면 생성
                        var player = new YT.Player(slideId, {
                            videoId: $youtubeSlide.data('videoId'),
                            events: {
                                onReady: function (event) {
                                    var player = event.target;
                                    if ('youtube-player-' + (shoswiper.activeIndex+1) == slideId) {
                                        player.mute();
                                        player.playVideo();
                                    }
                                    self.shortsData.players[slideId] = event.target; // players 보관 (onReady된것만)
                                },
                                onStateChange: function (event) {
                                    if (event.data === YT.PlayerState.ENDED) {
                                        shoswiper.slideNext(); // 다음 슬라이드로 이동
                                    } else if (event.data === YT.PlayerState.PLAYING) {
                                        var index = shoswiper.activeIndex;
                                        var data = self.shortsData.list[index];
                                        self.pushDataLayer(data.storyTitle); // GA 태깅
                                    }
                                },
                            }
                        });
                        void 0;
                    }
                });

                // 만들어진 플레이어 중 DOM이 사라졌으면 플레이어 제거
                var playersKeys = Object.keys(self.shortsData.players).slice();
                $.each(playersKeys, function(index, key){
                    if (!domSlideIds.includes(key)) {
                        self.shortsData.players[key].destroy();
                        delete self.shortsData.players[key]; // 객체 참조 제거
                    }
                });

                // BTOCSITE-113566 접근성 개선
                $(document).find('#shorts-popup').find('.swiper-slide').attr('inert','true');
                $(document).find('#shorts-popup').find('.swiper-slide-active').removeAttr('inert');

            });

            // 브라우저 뒤로가기/앞으로가기 이벤트 처리
            $(window).on('popstate', function(e) {
                var urlParams = new URLSearchParams(window.location.search);
                self.requestData(urlParams, true); // popstate 이벤트로 인한 호출이므로 skipHistoryUpdate를 true로 전달
            });
        },

        // 1분퀵뷰 팝업 목록 조회 (모달팝업에서 데이터 추가)
        requestShortsData: function(page, clickIndex) {
            var self = this;
            var params = {storyType : 'quick-view', countPerPage : self.countPerPage};
            var urlParams = new URLSearchParams(window.location.search);
            urlParams.set('page', page);
            urlParams.forEach(function(value, key) {
                params[key] = value;
            });

            lgkorUI.requestKongAjax("displaysvc","/ajax/v1/story/retrieveStoryListInfo", {
                method: "POST",
                data: params,
                success: function(response) {
                    var data = response.data;
                    var listData = data && data.storyList instanceof Array ? data.storyList : [];
                    listData = listData.splice(clickIndex || 0);

                    $.extend(self.shortsData, {
                        list : self.shortsData.list.concat(listData), // 뒤에 추가
                        totalCount : data.storyListTotalCount || 0,
                        totalPageCount : data.pagination.totalCount || 1,
                        currentPage : data.pagination.page || 1
                    });

                    // 1분퀵뷰 팝업 slide 생성
                    self.makeShortsSlide(listData);
                },
                error: function(xhr, status, error) {
                    void 0;
                }
            }, false, false);
        },

        // 유튜브 URL에서  videoId 추출
        extractYouTubeVideoId: function(url) {
            var regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            var match = url.match(regex);
            return match ? match[1] : '';
        },

        // slide 생성 (appendSlide)
        makeShortsSlide: function(list) {
            var self = this;

            var page = parseInt(this.shortsData.currentPage || 1, 10); // 1분퀵뷰 팝업 현재 페이지 번호 
            var itemsPerPage = this.countPerPage; // 한 페이지에 표시되는 아이템 수
            var startIndex = (page - 1) * itemsPerPage;
            var listLen = this.shortsData.totalCount; // 전체 아이템 수

            var newSlides = [];
            if (shoswiper) {
                //데이터
                $.each(list, function(index, slide) {
                    $.extend(slide, {index: startIndex + index, listLen : listLen});
                    if (slide.storyMovieGubun == 'youtube') {
                        slide.videoId = self.extractYouTubeVideoId(slide.storyMovieUrl);
                    }
                    newSlides.push(vcui.template(shortsTemplate, slide));
                });

                shoswiper.virtual.appendSlide(newSlides);

                if (shoswiper.virtual.slides.length == 1 && this.shortsData.totalCount > 1) {
                    // 슬라이드 한개인 경우 다음페이지까지 로드 후 업데이트 진행
                    if (this.shortsData.totalPageCount == this.shortsData.currentPage) {
                       this.requestShortsData(1);
                    } else {
                       this.requestShortsData(page+1);
                    }
                } else {
                    shoswiper.update();

                    if (this.shortsData.isFirst) {
                        shoswiper.slideTo(0); // 클릭한 아이템
                        this.shortsData.isFirst = false;

                        setTimeout(function () {
                            // 동일 인덱스로 이동한 경우 수동으로 이벤트 발생
                            shoswiper.emit('slideChangeTransitionEnd');
                        }, 100);

                    } else {
                        shoswiper.slideTo(shoswiper.virtual.slides.length - list.length - 1);
                    }
                }
            }
        },

        // 슈퍼카테고리 조회
        requestSuperCategoryData: function(urlParams) {
            var self = this;
            var params = {storyType : 'quick-view', countPerPage : self.countPerPage};
            var $header = $('div.page-header');
            lgkorUI.requestKongAjax("displaysvc", "/ajax/v1/story/retrieveStoryListInfo", {
                method: "POST",
                data: params,
                success: function(response) {
                    var data = response.data;
                    var superCategoryData = data && data.superCategoryList instanceof Array ? data.superCategoryList : [];
                    if (superCategoryData.length > 0) {
                         $header.find('ul.tabs').html(vcui.template(superCategoryTemplate, {list : superCategoryData}));
                    } else {
                        $header.remove();
                    }

                    // URLSearchParams에서 모든 파라미터를 객체로 변환
                    urlParams.forEach(function(value, key) {
                        params[key] = value;
                    });
                    // 탭의 'on' 클래스 업데이트
                    self.updateTabClasses(params);
                },
                error: function(xhr, status, error) {
                    void 0;
                }
            }, true, true);
        },

        // 목록 조회
        requestData: function(urlParams, skipHistoryUpdate) {
            var self = this;
            var $contents = $('div.story-list-wrap');
            var $itemList = $contents.find('ul.story-list-box');

            // URLSearchParams에서 모든 파라미터를 객체로 변환
            var params = {storyType : 'quick-view', countPerPage : self.countPerPage};
            urlParams.forEach(function(value, key) {
                params[key] = value;
            });

            // popstate 이벤트로 인한 호출이 아닌 경우에만 URL 업데이트
            if (!skipHistoryUpdate) {
                var queryString = urlParams.toString();
                if (queryString != '') {
                    history.pushState(null, '', window.location.pathname + '?' + queryString);
                }
            }

            lgkorUI.requestKongAjax("displaysvc", "/ajax/v1/story/retrieveStoryListInfo", {
                method: "POST",
                data: params,
                success: function(response) {
                    var data = response.data;

                    // 목록
                    var listData = data && data.storyList instanceof Array ? data.storyList : [];
                    if (listData.length > 0) {
                        self.$pagination.show();
                        $itemList.html(vcui.template(listTemplate, {list : listData}));
                        lgkorUI._addImgOnloadEvent(); // no-img 처리
                        $itemList.show();
                    } else {
                        $itemList.hide();
                        self.$pagination.hide();
                    }

                    // 페이징
                    if (data && data.pagination) {
                        self.$pagination.vcPagination('setPageInfo', data.pagination);
                    }

                    if (skipHistoryUpdate) {
                        // 탭의 'on' 클래스 업데이트
                        self.updateTabClasses(params);
                    }

                    // 포커스 - 초기 로드가 아닌 경우에만 포커스 이동
                    if (!self.isInitialLoad) {
                        $itemList.find('li:first a').focus();
                    }
                    self.isInitialLoad = false;
                },
                error: function(xhr, status, error) {
                    $itemList.hide();
                    self.$pagination.hide();
                    void 0;
                }
            }, true, true);
        },

        updateTabClasses: function(params) {
            // on
            var $tabList = $('div.page-header ul.tabs');
            if ($tabList.length > 0) {
                $('div.page-header ul.tabs').find('li').removeClass('on');
                var $selectedTab = $tabList.find('[data-category=' + params.superCategoryId + ']');
                if ($selectedTab.length > 0) {
                    $selectedTab.parent().addClass('on');
                } else {
                    $tabList.find('li:first').addClass('on'); // 없으면 첫번째
                }

                // '선택됨' 텍스트 업데이트
                $tabList.find('em').remove();
                $tabList.find('li.on a').append('<em class="blind">선택됨</em>');
            }
        },

        // GA 태깅
        pushDataLayer: function(eventLabel) {
            if(dataLayer) {
                dataLayer.push({
                    'event': 'customEvent',
                    'ga4event' : 'video_play',
                    'customEventCategory': '비디오',
                    'customEventAction': '1분 퀵뷰 재생',
                    'customEventLabel': eventLabel || ''
                });
            }
        }

    };

    $(document).ready(function() {
        quickView.init();
    });

})();